import { assignCommonProperties } from '../util/data/assign-common-properties.js'
import type { BranchNameType } from '../types.js'
import { Setting } from '../settings/setting.js'
import { BusinessObject } from '../bos/business-object.js'
import {
	jsonArrayProperty,
	jsonProperty,
	jsonClass,
} from '@sumbricht/json-class-serializer'
import { BoReference } from '../bos/bo-reference.js'

@jsonClass('DeploymentContainer')
export class DeploymentContainer {
	@jsonProperty(String)
	get __type() {
		return 'DeploymentContainer'
	}
	set __type(_) {}

	@jsonProperty(String)
	branchName!: BranchNameType
	@jsonArrayProperty(String)
	boJsons: string[] = []
	@jsonArrayProperty(Setting)
	settings: Setting[] = []

	#boRefsCache: BoReference[] | undefined
	get boRefs() {
		if (!this.#boRefsCache) {
			this.#boRefsCache = this.boJsons.map((boJson) =>
				new BusinessObject(JSON.parse(boJson)).getBoReference(),
			)
		}
		return this.#boRefsCache
	}

	constructor(init?: Partial<DeploymentContainer>) {
		assignCommonProperties(this, init)
	}
}
